import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { BannerPart } from './vscode/src/vs/workbench/browser/parts/banner/bannerPart.js';
import { IBannerService } from 'vscode/vscode/vs/workbench/services/banner/browser/bannerService.service';
import { registerServiceInitializePostParticipant } from 'vscode/lifecycle';
import './vscode/src/vs/workbench/contrib/welcomeBanner/browser/welcomeBanner.contribution.js';

function getServiceOverride() {
    return {
        [( IBannerService.toString())]: new SyncDescriptor(BannerPart, [], false)
    };
}
registerServiceInitializePostParticipant(async (accessor) => {
    accessor.get(IBannerService);
});

export { BannerPart, getServiceOverride as default };
